import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="folder-toggle"
// Handles toggling folder open/closed states
export default class extends Controller {
  static targets = ["icon", "content"]

  toggle() {
    const icon = this.iconTarget
    const content = this.contentTarget

    if (icon.classList.contains('bi-folder2-open')) {
      // Close the folder
      icon.classList.remove('bi-folder2-open')
      icon.classList.add('bi-folder2')
      content.style.display = 'none'
    } else {
      // Open the folder
      icon.classList.remove('bi-folder2')
      icon.classList.add('bi-folder2-open')
      content.style.display = ''
    }
  }
}
